
import React from 'react';
import Layout from '../../components/Layout';
import SubNavBar from "../../components/SubNavBar/SubNavBar"
import Support from './Support';

// Client Support hub (web parity with the mobile app's Support screen): contact channels
// (Email / Phone / WhatsApp) read from the public site settings + a link to the Help/FAQ center.
function action({ store, params, query }) {
  const siteSettings = store.getState().siteSettings?.data || {};
  const title = siteSettings?.siteTitle
  const description = siteSettings?.metaDescription;
  let isAuthenticated = store.getState().runtime.isAuthenticated;

  // Support is a PUBLIC page (reachable by logged-out visitors too); the account SubNavBar only
  // shows when authenticated.
  return {
    title,
    description,
    component: (
      <Layout>
        <div className={isAuthenticated ? "subPageMainContainer" : "withoutPageMainContainer"}>
          {isAuthenticated && <SubNavBar />}
          <Support
            contactEmail={siteSettings?.contactEmail}
            contactPhoneNumber={siteSettings?.contactPhoneNumber}
            whatsApp={siteSettings?.whatsApp}
          />
        </div>
      </Layout>
    ),
  };
}

export default action;
